import React from 'react';
import { columnWidth, renderCheckboxList } from 'utils/async-list';
import { Column } from 'react-virtualized';
import $ from 'jquery';
import ReactDOM from 'react-dom';
import VacationModal from 'modules/saas/users/vacation/VacationModal';
import {
  getVacationDetail,
  saveVacationDetail,
  updateVacationDetail,
} from 'modules/saas/users/api';
import { error } from 'plugins/toastr';
import { bindCreationGeocoding } from 'modules/saas/customers';

export function list() {
  const rowClickedUrl = id => `/pco-manager/users/${id}`;
  const loadNextUrl = '/pco-manager/users.json';

  renderCheckboxList(rowClickedUrl, loadNextUrl, renderColumns);
}

export const vacations = ctx => {
  const $createButton = $('button.vacation-create');
  const $updateButton = $('button.vacation-edit');
  const root = document.getElementById('vacation-modal-container');

  if ($updateButton && $updateButton.length) {
    $updateButton.off('click').on('click', evt => {
      const $target = $(evt.currentTarget);
      const $id = $target.data('id');

      const onClose = () => {
        ReactDOM.unmountComponentAtNode(root);
      };

      const onSave = body => {
        return updateVacationDetail($id, body).then(
          res => {
            window.location.replace(res.url);
          },
          err => {
            error('Une erreur de sauvegarde est survenue');
            return err.res.json();
          }
        );
      };

      getVacationDetail($id).then(res => {
        ReactDOM.render(
          <VacationModal
            title="Modifier l'absence"
            vacation={res}
            onClose={onClose}
            onSaved={onSave}
          />,
          root
        );
      });
    });
  }

  if ($createButton && $createButton.length) {
    const onClose = () => {
      ReactDOM.unmountComponentAtNode(root);
    };

    const onSave = body => {
      return saveVacationDetail(ctx.params.id, body).then(
        res => {
          window.location.replace(res.url);
        },
        err => {
          error('Une erreur de sauvegarde est survenue');
          return err.res.json();
        }
      );
    };

    $createButton.on('click', evt => {
      ReactDOM.render(
        <VacationModal
          title="Créer une absence"
          onClose={onClose}
          onSaved={onSave}
        />,
        root
      );
    });
  }
};

export const editPoint = ctx => {
  const $form = $('form');
  bindCreationGeocoding($form);
};

function renderColumns(width) {
  return [
    <Column
      key="email"
      dataKey="email"
      width={columnWidth(width, 5)}
      label="Email"
    />,
    <Column
      key="last_name"
      dataKey="last_name"
      width={columnWidth(width, 3)}
      label="Nom"
    />,
    <Column
      key="first_name"
      dataKey="first_name"
      width={columnWidth(width, 3)}
      label="Prénom"
    />,
    <Column
      key="extended_rights"
      dataKey="extended_rights"
      width={columnWidth(width, 3)}
      cellRenderer={renderRights}
      label="Droits avancés"
    />,
    <Column
      key="role"
      className="right aligned"
      dataKey="role"
      width={columnWidth(width, 2)}
      cellRenderer={renderRole}
      label="Type"
    />,
  ];
}

function renderRights(row) {
  const { cellData } = row;

  if (!!cellData) {
    return (
      <div>
        <i className="ui check icon" />
      </div>
    );
  }
  return <div />;
}

function renderRole(row) {
  const { cellData } = row;

  return cellData === 'pco_manager' ? (
    <div className="ui orange label">Manager</div>
  ) : (
    <div className="ui brown label">Technicien</div>
  );
}

export function bindDetail() {
  $('#resetDispo').on('click', evt => {
    evt.preventDefault();
    $('#dispos input[type=text]').val('');
    $('#dispos input[type=text]')
      .parent()
      .removeClass('error');
  });
}

export function create() {
  const $roleDiv = $('#role').parent()[0];
  const $role = $('.dropdown').find('[data-value="pco_manager"]')[0];
  const $extendedRights = $('#extended_rights')[0];

  // initialization
  if ($role.classList.contains('selected')) {
    $extendedRights.checked = true;
    $extendedRights.setAttribute('readonly', '');
    $extendedRights.parentElement.classList.add('disabled');
  } else {
    $extendedRights.removeAttribute('readonly');
    $extendedRights.parentElement.classList.remove('disabled');
  }

  // onClick
  $roleDiv.onclick = function(event) {
    const $managerRole = $('.dropdown').find('[data-value="pco_manager"]')[0];
    const $extendedRights = $('#extended_rights')[0];
    if ($managerRole.classList.contains('selected')) {
      $extendedRights.checked = true;
      $extendedRights.setAttribute('readonly', '');
      $extendedRights.parentElement.classList.add('disabled');
    } else {
      $extendedRights.removeAttribute('readonly');
      $extendedRights.parentElement.classList.remove('disabled');
    }
  };
}



// WEBPACK FOOTER //
// ./src/modules/saas/users/index.js